import { Navigate } from "react-router-dom";
import { useCurrentUser } from "./currentUser";
import { hasTeamAccess } from "./permissions";
import Loading from "./Loading";

export default function ProtectedTeamRoute({ team, children }) {
  const { user, loading } = useCurrentUser();

  if (loading) return <Loading />;
  if (!hasTeamAccess(user, team)) return <Navigate to="/" replace />;

  return children;
}
